import { useState } from "react";
import ProfileForm from "@app/components/ProfileForm";
import { ModalContainer, ModalBody, ModalHeader, ModalFooter } from "@app/components/Modal";
import useUser from "@app/zustand/user";
import { refreshUser } from "@app/utils/use-most-fresh-user";

export default function ProfileEdit({ open, setOpen }: { open: boolean; setOpen: (open: boolean) => void }) {
  const me = useUser((state) => state.user!);
  const [loading, setLoading] = useState(false);

  return (
    <ModalContainer className="h-full w-full flex-col overflow-hidden md:h-4/5 md:max-w-3xl" open={open}>
      <ModalHeader title="Modifier mon profil" onClose={() => setOpen(false)} />
      <ModalBody>
        <div className="h-full w-full overflow-auto p-4">
          <ProfileForm
            id="edit-form"
            defaultValues={me}
            canDelete
            onOk={() => {
              setOpen(false);
              refreshUser("ProfileEdit");
            }}
            setLoading={setLoading}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="inline-block rounded-lg border border-sky-800 bg-white px-5 py-1 text-sky-800"
          onClick={() => setOpen(false)}
        >
          Annuler
        </button>
        <button
          className="inline-block rounded-lg border-none bg-sky-800 px-5 py-1 text-white disabled:pointer-events-none disabled:opacity-30"
          type="submit"
          form="edit-form"
          disabled={loading}
        >
          {loading ? "Chargement..." : "Enregistrer"}
        </button>
      </ModalFooter>
    </ModalContainer>
  );
}
